import { useContext } from "react";
import { NegativationDashboardContext } from "./NegativationDashboard.context";

export function useNegativationDashboardContext() {
  const context = useContext(NegativationDashboardContext)

  if (!context) {
    throw new Error("useNegativationDashboardContext deve ser utilizado apenas dentro de NegativationDashboardProvider")
  }

  return context
}